import heic2any from "heic2any";
import axiosInstance from "../config/axios/axios.config";

export const resizeImage = (image, quality = 0.7) => {
  let file = image.originFileObj || image;
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = 800;
        canvas.height = 600;
        const ctx = canvas.getContext("2d");

        // Calculate scaling and positioning to maintain aspect ratio
        const scale = Math.max(800 / img.width, 600 / img.height);
        const x = (800 - img.width * scale) / 2;
        const y = (600 - img.height * scale) / 2;

        ctx.fillStyle = "#FFFFFF"; // Fill with white background
        ctx.fillRect(0, 0, 800, 600);
        ctx.drawImage(img, x, y, img.width * scale, img.height * scale);

        const mimeType = file.type === "image/png" ? "image/png" : "image/jpeg";
        canvas.toBlob(
          (blob) => {
            if (blob) {
              resolve(
                new File([blob], file.name, {
                  type: mimeType,
                  lastModified: Date.now(),
                })
              );
            } else {
              reject(new Error("Image compression failed."));
            }
          },
          mimeType,
          quality
        );
      };
      img.onerror = (error) => {
        console.error(error);
        reject(new Error("Failed to load image."));
      };
      img.src = e.target.result;
    };
    reader.onerror = () => reject(new Error("Failed to read file."));
    reader.readAsDataURL(file);
  });
};

export const normalizeImage = async (file) => {
  let processedFile = file;
  let type = file.type;

  if (file.name.toLowerCase().endsWith(".heic")) {
    if (!type || type === "image/heic") {
      try {
        const jpegBlob = await heic2any({
          blob: file.originFileObj || file,
          toType: "image/jpeg",
          quality: 0.8,
        });
        processedFile = new File(
          [jpegBlob],
          file.name.replace(/\.heic$/i, ".jpg"),
          { type: "image/jpeg" }
        );
        type = "image/jpeg";
      } catch (conversionError) {
        type = "application/octet-stream";
      }
    }
  }
  let finalFile = await resizeImage(processedFile);
  return { name: processedFile.name, type, file: finalFile };
};

export const formattFiles = async (files) => {
  return await Promise.all(
    files.map(async (file) => {
      return await normalizeImage(file.originFileObj || file);
    })
  );
};

/** Upload normalized AVV images to the API; returns public S3 URLs for AVV `media` links. */
export const uploadAvvMediaFiles = async (files) => {
  const formData = new FormData();
  files.forEach(({ file }) => {
    formData.append("files", file, file.name);
  });
  const { data: { fileUrls } = {} } = await axiosInstance.post(
    "widgets/avv/upload_files/",
    formData
  );
  if (!fileUrls || !Array.isArray(fileUrls)) {
    throw new Error("Invalid response from server");
  }
  return fileUrls;
};
